export default (state = {}, action) => {
  let { type, payload } = action
  switch (type) {
    case 'VENDORS_SET':
      return Object.assign({}, state, payload)
    case 'LOGOUT':
      return {}
    default:
      return state
  }
}